import type { ChainConfig } from "@/domains/core"
import { appConfig } from "@/config/app-config"

export const useChainConfig = () => {
  return appConfig as ChainConfig
}
